import React from 'react';
import './index.css';
import App from './app/App';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './app/hoc/AuthProvider';


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

reportWebVitals();